import React, { useState, useEffect, useCallback } from 'react';
import SongCard from './SongCard';
import { api } from '../services/api';

const TABS = [
  { id:'queue',  label:'🕐 По очереди' },
  { id:'likes',  label:'♥ По лайкам' },
  { id:'played', label:'✓ Воспроизведены' },
];

export default function SongPortal({ roomCode, isDj }) {
  const [songs,    setSongs]    = useState({ queue:[], byLikes:[], played:[] });
  const [tab,      setTab]      = useState('queue');
  const [title,    setTitle]    = useState('');
  const [adding,   setAdding]   = useState(false);
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(true);

  const fetch = useCallback(async () => {
    try {
      const data = isDj ? await api.djGetSongs() : await api.getRoomSongs(roomCode);
      setSongs(data);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [roomCode, isDj]);

  useEffect(() => {
    fetch();
    const t = setInterval(fetch, 5000);
    return () => clearInterval(t);
  }, [fetch]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    setAdding(true); setError('');
    try {
      await api.addSong(roomCode, title.trim());
      setTitle('');
      await fetch();
      setTab('queue');
    } catch(err) { setError(err.message); }
    finally { setAdding(false); }
  };

  const handleLike = async (id) => {
    try { await api.toggleLike(roomCode, id); await fetch(); }
    catch(e) { console.error(e); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить эту песню?')) return;
    try {
      isDj ? await api.djDeleteSong(id) : await api.deleteSong(roomCode, id);
      await fetch();
    } catch(e) { setError(e.message); }
  };

  const handleTogglePlayed = async (id, isPlayed) => {
    try {
      isPlayed ? await api.djUnmarkPlayed(id) : await api.djMarkPlayed(id);
      await fetch();
    } catch(e) { setError(e.message); }
  };

  const list = tab === 'queue' ? songs.queue : tab === 'likes' ? songs.byLikes : songs.played;
  const total = songs.queue.length + songs.played.length;

  if (loading) return (
    <div className="loading-screen">
      <div className="spinner lg" /><span>Загружаем список...</span>
    </div>
  );

  return (
    <div className="portal">
      <div className="container">
        {!isDj && (
          <form className="add-song-bar" onSubmit={handleAdd}>
            <input className="input" type="text" placeholder="Название песни или исполнитель..."
              value={title} onChange={e => setTitle(e.target.value)} maxLength={200} />
            <button className="btn btn-primary" type="submit" disabled={adding || !title.trim()}>
              {adding ? <span className="spinner" /> : '+ Добавить'}
            </button>
          </form>
        )}

        {error && <div className="alert alert-error" style={{marginBottom:12}}>{error}</div>}

        <div className="stats-bar">
          <div className="stat"><span className="stat-label">В очереди</span><span className="stat-val">{songs.queue.length} 🎵</span></div>
          <div className="stat"><span className="stat-label">Сыграно</span><span className="stat-val">{songs.played.length} ✓</span></div>
          <div className="stat"><span className="stat-label">Лайков</span><span className="stat-val">{[...songs.queue,...songs.played].reduce((s,x)=>s+x.likesCount,0)} ♥</span></div>
        </div>

        <div className="tabs">
          {TABS.map(t => (
            <button key={t.id} className={`tab ${tab===t.id?'active':''}`} onClick={()=>setTab(t.id)}>
              {t.label}
              {t.id==='queue'  && songs.queue.length  > 0 && <span className="tab-badge">{songs.queue.length}</span>}
              {t.id==='played' && songs.played.length > 0 && <span className="tab-badge green">{songs.played.length}</span>}
            </button>
          ))}
        </div>

        <div className="song-list">
          {list.length === 0 ? (
            <div className="song-empty">
              <div className="song-empty-icon">{tab==='queue'?'🎵':tab==='likes'?'♡':'✓'}</div>
              {tab==='queue'  && (isDj ? 'Очередь пуста.' : 'Очередь пуста — добавьте первую!')}
              {tab==='likes'  && 'Нет песен с лайками.'}
              {tab==='played' && 'Пока ничего не сыграно.'}
            </div>
          ) : list.map((s,i) => (
            <SongCard key={s.id} song={s} index={i} isDj={isDj}
              showRank={tab==='likes'}
              onLike={handleLike} onDelete={handleDelete} onTogglePlayed={handleTogglePlayed} />
          ))}
        </div>
      </div>
    </div>
  );
}
